import { useQuery } from "@tanstack/react-query";
import { dataSource } from "@/lib/data-source";
import { queryKeys } from "@/lib/query-keys";

export function useDepartments() {
  return useQuery({
    queryKey: queryKeys.departments,
    queryFn: () => dataSource.listDepartments(),
  });
}
